<ng-container *ngIf="budget as currentBudget; else budgetFallback">
    <div
        [ngbPopover]="popContent"
        popoverTitle="{{ currentBudget.budgetType }} of {{ currentBudget.linkedEmployee?.firstName || '' }} {{ currentBudget.linkedEmployee?.lastName || '' }}"
        triggers="mouseenter:mouseleave">
        <a
            (click)="openBudgetDetailModel()"
            [ngClass]="{ archived: currentBudget.archived }"
            class="pill">
            <i class="las la-wallet"></i>
            <i
                *ngIf="currentBudget.recurring"
                class="las la-redo-alt"></i>
            {{ currentBudget.budgetType }}
            <i
                *ngIf="attentionLevel === 2"
                class="las la-exclamation-circle"></i>
            <i
                *ngIf="attentionLevel === 1"
                class="las la-exclamation-triangle"></i>
        </a>
    </div>
</ng-container>

<ng-template #budgetFallback>
    <span class="pill">
        <i class="las la-wallet"></i>
        {{ fallbackLabel || 'Budget' }}
    </span>
</ng-template>

<ng-template #popContent>
    <table class="table-view">
        <tr>
            <th>Budgeted cost</th>
            <th *ngIf="budget?.useExpendituresForFinancials">Actual cost</th>
            <th *ngIf="!budget?.recurring">Expiration date</th>
        </tr>
        <tr>
            <td>
                {{ $safeNavigationMigration(budget?.totalSpend) | currency : 'EUR' }}
            </td>
            <td *ngIf="budget?.useExpendituresForFinancials">
                {{ (budget?.totalSpend || 0) - totalSpend | currency : 'EUR' }}
            </td>
            <td *ngIf="!budget?.recurring">
                {{ $safeNavigationMigration(budget?.endDate) | date }}
            </td>
        </tr>
    </table>
</ng-template>
